import * as React from 'react'

import { Communication }              from '../../redux/index'
import { ReactComponent }             from '../../types'
import withDialogControls             from '../hocs/withDialogControls'
import { InjectedDialogControlProps } from './withDialogControls'

interface Props {
  communication: Communication
}

type WrappedComponentProps =
  Props
  & InjectedDialogControlProps

function withOnCommunicationSuccessClose<P> (Component: ReactComponent<P & Props>) {
  class WithOnSuccessClose extends React.Component<P & WrappedComponentProps> {
    public componentDidUpdate (lastProps: P & WrappedComponentProps) {
      if (
        lastProps.communication.fetching
        && this.props.communication.success
      ) {
        this.props.close()
      }
    }

    public render () {
      return (
        <Component {...this.props} />
      )
    }
  }

  return withDialogControls(WithOnSuccessClose as any)
}

export default withOnCommunicationSuccessClose



// WEBPACK FOOTER //
// ./src/components/hocs/withOnCommunicationSuccessClose.tsx